import React, { useState, useEffect } from "react";
import MessageList from "./MessageList";
import MessageInput from "./MessageInput";
import { FiMoreVertical } from "react-icons/fi";

const ChatWindow = ({ currentUser }) => {
  const [chatMessages, setChatMessages] = useState([]);
  const [connectedUsers, setConnectedUsers] = useState([]);
  const [ws, setWs] = useState(null);

  useEffect(() => {
    // ✅ 1. Charger l’historique des messages via FETCH
    const fetchMessages = async () => {
      try {
        const response = await fetch("https://api.lii.com.co:5101/api/chat/messages");
        const data = await response.json();
        setChatMessages(data.messages || []);
      } catch (error) {
        console.error("❌ Error fetching messages:", error);
      }
    };

    fetchMessages(); // 📩 Chargement à l’ouverture du chat

    // ✅ 2. Connexion WebSocket
    const socket = new WebSocket("wss://api.lii.com.co:5101");
    setWs(socket);

    socket.onopen = () => {
      console.log("✅ WebSocket ouvert");
      if (currentUser) {
        socket.send(
          JSON.stringify({
            type: "userConnected",
            user: {
              firstName: currentUser.firstName,
              lastName: currentUser.lastName,
            },
          })
        );
      }
    };

    socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.type === "updateUserList") {
        setConnectedUsers(data.users);
      } else if (data.type === "receiveMessage") {
        setChatMessages((prev) => [...prev, data]);
      } else if (data.type === "deleteMessage") {
        setChatMessages((prev) => prev.filter((msg) => msg._id !== data.id));
      }
    };

    return () => socket.close();
  }, [currentUser]);

  const handleSendMessage = (message) => {
    if (ws) {
      ws.send(
        JSON.stringify({
          type: "sendMessage",
          sender: currentUser,
          content: message.content,
        })
      );
    }
  };

  const handleDeleteMessage = (id) => {
    if (ws) {
      ws.send(JSON.stringify({ type: "deleteMessage", id }));
    }
  };

  return (
    <div className="chat-window fixed bottom-4 right-4 bg-white w-96 h-[450px] rounded-2xl shadow-2xl p-5 flex flex-col justify-between z-50">
      <div className="message-header bg-blue-600 text-white p-3 rounded-t-2xl flex justify-between items-center">
        <h2 className="text-lg font-semibold">💬 Messaging</h2>
        <div className="space-y-1 text-sm">
          {connectedUsers.map((user, index) => (
            <p key={index}>
              🟢 {user.firstName} {user.lastName}
            </p>
          ))}
        </div>
      </div>
      <div className="message-list-container overflow-y-auto flex-1 py-4 px-2 bg-gray-50 rounded-lg">
        <MessageList
          messages={chatMessages}
          currentUser={currentUser}
          onDelete={handleDeleteMessage}
        />
      </div>
      <div className="message-input-container mt-2">
        <MessageInput onSend={handleSendMessage} />
      </div>
    </div>
  );
};

export default ChatWindow;